import { render, staticRenderFns } from "./MenuTreeNode.vue?vue&type=template&id=c3e72a04&scoped=true&"
import script from "./MenuTreeNode.vue?vue&type=script&lang=ts&"
export * from "./MenuTreeNode.vue?vue&type=script&lang=ts&"
import style0 from "./MenuTreeNode.vue?vue&type=style&index=0&id=c3e72a04&scoped=true&lang=css&"
import style1 from "./MenuTreeNode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e72a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VDivider,VFlex,VIcon,VLayout})
